import React from 'react';
import { Box } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';

/**
 * Visual metric indicator using filled/empty circles
 * 
 * Examples:
 * - value=3: ●●●
 * - value=2: ●●○
 * - value=1: ●○○
 * - value=0: ○○○
 */
const MetricDots = ({ value, maxValue = 3, size = 'small' }) => {
  const getColor = (val) => {
    if (val === 3) return '#22c55e'; // Green
    if (val === 2) return '#3b82f6'; // Blue
    if (val === 1) return '#f59e0b'; // Yellow
    return '#ef4444'; // Red
  };

  const iconSize = size === 'small' ? 12 : 16;
  const color = getColor(value);

  return (
    <Box sx={{ display: 'flex', gap: 0.25, alignItems: 'center' }}>
      {Array.from({ length: maxValue }).map((_, index) => (
        index < value ? (
          <CircleIcon 
            key={index} 
            sx={{ fontSize: iconSize, color }} 
          />
        ) : (
          <CircleOutlinedIcon 
            key={index} 
            sx={{ fontSize: iconSize, color: '#d1d5db' }} 
          />
        )
      ))}
    </Box>
  );
};

export default MetricDots;
